import { Injectable } from '@angular/core';
import { AbstractControlOptions, FormArray, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PledgeRead } from '@app/forms/subscription/definition/interface/Pledge';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generate(entity: PledgeRead) {
    let options: AbstractControlOptions = {};
    return this.formBuilder.group(
      {
        accountInformations: this.formBuilder.group({
          investmentGoals: [
            entity?.accountInformations?.investmentGoals || null,
            Validators.required,
          ],
        }),
      },
      options,
    );
  }

  get owners() {
    return this.form.get('owners') as FormArray;
  }
  get accountInformations() {
    return this.form.get('accountInformations') as FormArray;
  }
  extract() {
    return this.form.value;
  }
}
